import { useStaticQuery, graphql } from "gatsby"

export const useFooterData = () => {
  const data = useStaticQuery(graphql`
    query footer {
      contentfulSectionFooterCompanyInfoJsonNode {
        links {
          link
          text
          type
        }
        name
      }
      contentfulSectionFooterMiddleContentJsonNode {
        Rows {
          links {
            link
            name
          }
          name
        }
      }
      contentfulSectionFooterLegalLinksJsonNode {
        links {
          link
          text
        }
      }
    }
  `)

  return {
    sectionMiddle: data.contentfulSectionFooterMiddleContentJsonNode.Rows,
    sectionCompany: data.contentfulSectionFooterCompanyInfoJsonNode,
    sectionLegal: data.contentfulSectionFooterLegalLinksJsonNode,
  }
}
